import React from 'react';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';

import { useLocation } from 'react-use';
import { NextSeo } from 'next-seo';
import Banner from '@/components/Teachers/Banner';
import TeacherScreening from '@/components/Teachers/TeacherScreening';
import TeachingService from '@/components/Teachers/TeachingService';
import Layout from '@/components/Layout';
import dynamic from 'next/dynamic';

const TeacherShow = dynamic(import('@/components/Teachers/TeacherShow'), { ssr: false });

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'teachers', 'path', 'form'])),
    },
  };
};

const Teachers = () => {
  const { t } = useTranslation(['teachers', 'common']);
  const state = useLocation();
  return (
    <>
      <NextSeo
        openGraph={{
          url: state?.href,
          title: t('common:seo-悟空师资-title'),
          description: t('common:seo-悟空师资-description'),
          images: [
            {
              url: 'https://cdnwukong.com/images/public/og/offical-site-1.png',
              width: 300,
              height: 300,
              alt: t('common:seo-悟空师资-title'),
            },
          ],
        }}
      />
      <Head>
        <title>{t('common:seo-悟空师资-title')}</title>
        <meta name="description" content={t('common:seo-悟空师资-description')} />
        <meta name="keywords" content={t('common:seo-悟空师资-关键词')} />
        <meta
          data-n-head="ssr"
          data-hid="apple-mobile-web-app-title"
          name="apple-mobile-web-app-title"
          content={t('common:seo-悟空师资-title')}
        />
      </Head>
      <div className="pt-[110px]">
        {/* banner  */}
        <Banner />

        {/* 悟空名师展示 */}
        <TeacherShow />

        {/* 悟空老师筛选 */}
        <TeacherScreening />

        {/* 教学服务 */}
        <TeachingService />
      </div>
    </>
  );
};

export default Teachers;

Teachers.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;
